document.addEventListener("DOMContentLoaded", function() {

  const tabsWrapper = document.querySelector(".custom-product-tabs");

  if (!tabsWrapper) return;

  const isAccordion = tabsWrapper.classList.contains("accordion-mobile");
  const buttons = tabsWrapper.querySelectorAll(".tab-button");
  const contents = tabsWrapper.querySelectorAll(".tab-content");

  // Desktop Tabs
  buttons.forEach(button => {
    button.addEventListener("click", function() {

      buttons.forEach(btn => btn.classList.remove("active"));
      contents.forEach(content => content.classList.remove("active"));

      button.classList.add("active");
      tabsWrapper.querySelector("#" + button.dataset.tab).classList.add("active");

    });
  });

  // Mobile Accordion
  if (isAccordion) {

    const triggers = tabsWrapper.querySelectorAll(".accordion-trigger");

    triggers.forEach(trigger => {

      trigger.addEventListener("click", function() {

        const parentContent = trigger.closest(".tab-content");

        // Close all
        contents.forEach(content => {
          content.classList.remove("active");
        });

        // Toggle current
        if (!parentContent.classList.contains("active")) {
          parentContent.classList.add("active");
        }

      });

    });

  }

});